export const AUTH_URL = "/api/game/auth/login";
export const SOCKET_URL = "/api/game/socket";
